import ApplicationController from './application_controller'
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);


export default class extends ApplicationController {

	static values = {
		data: { type: Object, default: {} },
		chartType: { type: String, default: 'line' },
		options: { type: Object, default: {} },
		smartLabels: { type: Boolean, default: true },
	}

	connect() {
		this.initChart()
	}	

	disconnect() {
		if (this.chart) this.chart.destroy()
	}

	generateConfig() {
		const config = {
			type: this.chartTypeValue,
			data: this.dataValue,
			options: this.optionsValue,
		}

		if (this.smartLabelsValue) {
			config.options.plugins.tooltip ||= {}
			config.options.plugins.tooltip.callbacks = {
				label: function(tooltipItem) {
					const dataset = tooltipItem.dataset
					const total = dataset.total

					let value = null
					switch (dataset.dataValueProperty) {
						case 'array':
							value = dataset.data[tooltipItem.dataIndex]
							break
						case 'x':
							value = dataset.data[tooltipItem.dataIndex].x
							break
						case 'y':
							value = dataset.data[tooltipItem.dataIndex].y
							break
					}

					const percentage = ((value / total) * 100).toFixed(1)
					return ` ${dataset.label}: ${value} (${percentage}%)`
				}
			}
		}

		return config
	}

	initChart() {
		this.chart = new Chart(this.element, this.generateConfig())
	}
}
